import { useEffect, useRef } from 'react';

const useCursorGlow = () => {
  const glowRef = useRef(null);

  useEffect(() => {
    const glow = glowRef.current;
    if (!glow) return;

    const move = (e) => {
      glow.style.left = `${e.clientX}px`;
      glow.style.top = `${e.clientY}px`;
    };

    const show = () => { glow.style.opacity = '1'; };
    const hide = () => { glow.style.opacity = '0'; };

    document.addEventListener('mousemove', move);
    document.body.addEventListener('mouseenter', show);
    document.body.addEventListener('mouseleave', hide);

    return () => {
      document.removeEventListener('mousemove', move);
      document.body.removeEventListener('mouseenter', show);
      document.body.removeEventListener('mouseleave', hide);
    };
  }, []);

  return glowRef;
};

export default useCursorGlow;
